var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6133",
    "data-name": "Group 6133",
    transform: "translate(-276 -518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6132",
    "data-name": "Group 6132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5313",
    "data-name": "Path 5313",
    d: "M281,536h6v2h-4a1,1,0,0,0,0,2h10a1,1,0,0,0,0-2h-4v-2h6a5.01,5.01,0,0,0,4.9-4H276.1a5.01,5.01,0,0,0,4.9,4Z",
    fill: "#004fb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5314",
    "data-name": "Path 5314",
    d: "M295,518H281a5.005,5.005,0,0,0-5,5v7h24v-7a5.005,5.005,0,0,0-5-5Z",
    fill: "#004fb1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.b29494da50f93ed852da46bf9587a185.svg";
export { ForwardRef as ReactComponent };